import type { Apis } from '@efdigital/ll-addon-auth/types/apis';
import config from '@efdigital/ll-admin-v2/config/environment';
import type { ConstrainedRequestOptions } from '@warp-drive/core/types/request';

const apis: Apis = config['ll-addon-auth-apis'];

const PREFIX = `${apis.jsonApi.host}/${apis.jsonApi.namespace}/`;

export const jsonApiOptions: ConstrainedRequestOptions = {
  ...apis.jsonApi,
  urlParamsSettings: {
    arrayFormat: 'repeat',
  },
};

export function isJsonApiRequest(request: { url?: string }): boolean {
  return request.url?.startsWith(PREFIX) ?? false;
}
